import { OfflineDataEncryption } from '../../../utils/offlineDataEncryption/OfflineDataEncryption.util';
import { OfflineDatabase } from '../offlineDatabase';

export const addDecryptHookToOfflineDatabase = (offlineDatabase: OfflineDatabase) => {
  offlineDatabase.tables.forEach((table) =>
    table.hook('reading', (obj) => {
      const offlineDataEncryption = new OfflineDataEncryption();

      const tableIndexes = table.schema.indexes;

      if (obj) {
        const decryptedObjects = offlineDataEncryption.decryptOfflineData({
          input: obj,
          customFieldsToIgnore: tableIndexes
            .map((index) => index.keyPath)
            .flat()
            .filter(Boolean) as string[],
        });

        return decryptedObjects;
      }

      return obj;
    }),
  );
};
